const styles = (theme) => ({
  dataCollectedContainer: {
    padding: theme.spacing(1),
  },
  dataCollectedTable: {
    marginBottom: theme.spacing(2),
  },
  button: {
    padding: '0px',
  },
  buttonLabel: {
    textTransform: 'capitalize',
  },
  buttonTitle: {
    paddingLeft: '5px',
  },
  textTableRight: {
    textAlign: 'center',
  },
  actionHeader: {
    paddingRight: '70px',
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paperModal: {
    margin: theme.spacing(1),
    padding: theme.spacing(2, 2, 3),
    outline: 'none',
  },
  tableContainerModal: {
    marginTop: theme.spacing(2),
    maxHeight: 'auto',
  },
  iconMargin: {
    margin: theme.spacing(1),
  },
})

export default styles
